module.exports = __webpack_public_path__ + "img/shutters-multiple.03d4121d.svg";